export const CONSENT_EVENT = "lumiere-consent-change";

const META_LEADS = { consult_request: "Consult request", priority_list_join: "Priority access list", callback_requested: "Callback request" };

export const hasAnalyticsConsent = () => {
  if (typeof window === "undefined") return false;
  try {
    return localStorage.getItem("lumiere-consent") === "accepted";
  } catch {
    return false;
  }
};

const cookie = (name) => document.cookie.split("; ").find((c) => c.startsWith(`${name}=`))?.split("=")[1];

const uid = () => (window.crypto?.randomUUID ? window.crypto.randomUUID() : `${Date.now()}-${Math.random().toString(16).slice(2)}`);

// Shared browser + server Lead context (same event_id for Meta dedup). Only built once cookies are accepted.
export const leadContext = (name, category) => {
  if (!META_LEADS[name] || !hasAnalyticsConsent()) return undefined;
  return { event_id: uid(), url: window.location.href, fbp: cookie("_fbp"), fbc: cookie("_fbc"), content_name: META_LEADS[name], content_category: category || undefined };
};

export const trackEvent = (name, params = {}, lead) => {
  if (!hasAnalyticsConsent()) return;
  if (typeof window.gtag === "function") window.gtag("event", name, params);
  if (lead && typeof window.fbq === "function") {
    window.fbq("track", "Lead", { content_name: lead.content_name, content_category: lead.content_category }, { eventID: lead.event_id });
  }
};
